import React, { useState } from "react";
import styled from "styled-components";
import moment from "moment";

import { useTheme } from '../../../../Context/ThemeContext';
import { useLanguage } from '../../../../Context/LanguageContext';
import { lightTheme, darkTheme } from '../../../../Styles/theme';

import UserProfile from "../../../../Component/Normal/UserProfile";

import { ReactComponent as PlusSvg } from '../../../../image/Plus.svg';
import { ReactComponent as CheckSvg } from '../../../../image/Check.svg';

export default function ReservedMemberInfoBox(props) {
  const {
    memberData,
    index,
    totalLength,
    onViewUserPhone,
    onCalcButtonText,
    onClickMemberProfileOrText,
    onClickMemberExceptButton,
    onClickAttendanceButton
  } = props;

  const { isDark } = useTheme();
  const { t } = useLanguage();
  const theme = isDark ? darkTheme : lightTheme;

  const [isHover, setIsHover] = useState(false);
  const [tooltipPos, setTooltipPos] = useState({ top: 0, left: 0 });

  // 호버 시 툴팁 위치 계산 //
  function onMouseEnterInfoWrapper(e) {
    const rect = e.currentTarget.getBoundingClientRect();

    setTooltipPos({ top: rect.top - 20, left: rect.left + 28 });
    setIsHover(true);
  }

  // 회원권 남은 일수 표출여부 확인 //
  function isViewRemainMembership() {
    if (memberData.endDate === undefined) return false;

    const dateDiff = moment(memberData.endDate).diff(moment(), 'day');

    if (dateDiff > 7) return false;
    return true;
  }

  // 회원권 남은 일수 계산 //
  function decideRemainMembership() {
    const dateDiff = moment(memberData.endDate).diff(moment(), 'day');

    if (dateDiff === 0) return 'D-DAY';
    return 'D-' + dateDiff;
  }

  return (
    <InfoWrapper key={'Reserve-' + index} onMouseEnter={onMouseEnterInfoWrapper} onMouseLeave={() => setIsHover(false)}>
      <ImageTooltipWrapper isHover={isHover} top={tooltipPos.top} left={tooltipPos.left}>
        <ImageTooltip>
          <Text fontFamily='NotoSansKR-Medium' fontSize={12} color={theme.subBackground} cursor='default'>
            {t('reservation.requestTime') + moment(memberData.createdDate).format(t('reservation.requestDateFormat'))}
          </Text>
        </ImageTooltip>
        <Triangle />
      </ImageTooltipWrapper>
      <ImageWrapper
        onClick={() => onClickMemberProfileOrText(memberData)}>
        <UserProfile profile={memberData.profile} defaultProfile='https://picture.link-zone.org/ZoneLogo.png' />
      </ImageWrapper>
      <MemberDataWrapper>
        <ReserveNumberWrapper>
          <TotalTextWrapper onClick={() => onClickMemberProfileOrText(memberData)}>
            <TextWrapper>
              <NameWrapper>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} cursor='pointer'>{memberData.name}</Text>
              </NameWrapper>
              <PhoneWrapper>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} cursor='pointer'>{onViewUserPhone(memberData.phone, memberData.countryCode)}</Text>
              </PhoneWrapper>
            </TextWrapper>
          </TotalTextWrapper>
          <ReserveDdayBox isView={isViewRemainMembership()}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subBackground} cursor='pointer'>{decideRemainMembership()}</Text>
          </ReserveDdayBox>
        </ReserveNumberWrapper>

        <AttendanceCheckBox isComplete={(memberData.status === 1 || memberData.status === 2)}>
          <Text fontFamily='NotoSansKR-Medium' fontSize={13} color={theme.subText} cursor='pointer'>{onCalcButtonText(memberData)}</Text>
          <AttendanceCheck $isComplete={memberData.status === 1 || memberData.status === 2} onClick={() => onClickAttendanceButton(memberData)}>
            {(memberData.status === 1 || memberData.status === 2) && <StyledCheck />}
          </AttendanceCheck>
        </AttendanceCheckBox>

        <ReserveExitButton onClick={() => onClickMemberExceptButton(index)}>
          <StyledExitPlus />
        </ReserveExitButton>
      </MemberDataWrapper>
    </InfoWrapper>
  );
}

const InfoWrapper = styled.div`
  position: relative;

  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 96%;
  height: 42px;

  gap: 10px;

  overflow: visible;

  &:hover {
    cursor: pointer;
  }
`;

const ImageWrapper = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 42px;
  height: 42px;

  border-radius: 3px;

  overflow: hidden;

  & img {
    width: 42px;
    height: 42px;
    border-radius: 3px;
    object-fit: cover;
  }

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const ImageTooltipWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  top: ${props => props.top}px;
  left: ${props => props.left}px;

  opacity: ${props => props.isHover ? 1 : 0};

  z-index: ${props => props.isHover ? 1 : -1};

  transition: opacity 0.3s ease-in-out;
`;

const ImageTooltip = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 2px 5px;

  border-radius: 3px;
  background-color:${props => props.theme.primary};
`;

const Triangle = styled.div`
  margin-left: 10px;

  width: 0;
  height: 0;

  border-top: 5px solid ${props => props.theme.primary};
  border-right: 16px solid transparent;
`;

const MemberDataWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: calc(100% - 32px);
  min-width: 0;
  height: 42px;

  border-bottom: 1px solid ${props => props.theme.line};
  overflow: hidden;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const ReserveNumberWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 200px;
  overflow: hidden;
`;

const TotalTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  min-width: 0;
  flex: 1;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: 100%;
  min-width: 0;

  margin-bottom: 4px;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const NameWrapper = styled.div`
  width: 148px;
  height: 21px;
  line-height: 21px;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const PhoneWrapper = styled.div`
  width: 148px;
  height: 21px;
  line-height: 21px;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const ReserveExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 20px;
  height: 20px;

  border-radius: 20px;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const StyledExitPlus = styled(PlusSvg)`
  flex-shrink: 0;
  width: 17px;
  height: auto;

  transform: rotate(45deg);

  & path {
    fill: ${props => props.theme.line};
    transition: fill 0.3s;
  }

  &:hover path {
    fill: ${props => props.theme.pointRed};
  }
`;


const ReserveDdayBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 46px;
  height: 18px;

  border-radius: 17px;
  background-color: ${props => props.theme.primary};

  opacity: ${props => props.isView ? 1 : 0};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const AttendanceCheckBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 6px;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const AttendanceCheck = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 1px;

  width: 22px;
  height: 22px;

  border-radius: 22px;
  background-color: ${props => props.$isComplete ? props.theme.subKey : 'none'};
  border: ${props => props.$isComplete ? `1px solid ${props.theme.subKey}` : `1px dashed ${props.theme.line}`};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const StyledCheck = styled(CheckSvg)`
  flex-shrink: 0;
  width: 11px;
  height: auto;

  & path {
    fill: ${props => props.theme.subBackground};
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }
`;
